/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import UCButton from "../../../buttons/index.js";
import { colors } from "../../../../constants/colors.js";
import { useSpinnersContext } from "../../../../contexts/spinnersContext.js";

/* Styles */
import styles from "../styles.js"

const ConfirmDeleteFooter = props => {
  const { setShowModal, handleSaveModal, disableSubmit, submitText, btnSpinner  } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  const spinner = useSpinnersContext();

  return (
    <ContainerFluid className="gx-0">
      <Row>
        <Col className={classes.cancelBtnCol}>
          <UCButton
            onClick={() => setShowModal(false)}
            type="default"
            className={classes.cancelBtn}
            text={<FormattedMessage id="peopleGrid.deleteAction.cancel"/>}
          />
        </Col>
        <Col className={classes.saveBtnCol}>
          <UCButton
            className={`${classes.saveBtn} ${disableSubmit ? classes.customDisabled : ''}`}
            onClick={handleSaveModal}
            type="danger"
            text={submitText ? submitText : <FormattedMessage id="settings.confirmDeleteAction.deleteButtonText"/>}
            dataTestId="changelanguagesubmit"
            disabled={ disableSubmit }
            loadingStateStyling={ classes.customDisabled }
            spinner={{
              name: btnSpinner,
              size: 20,
              color: colors.white
            }}
          />
        </Col>
      </Row>
    </ContainerFluid>
  )
}

export default ConfirmDeleteFooter;